export default __webpack_public_path__ + "images/4C.9a3f298.png";